exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invoice-email-form[data-v-311b06aa]{text-align:left!important}.email-label[data-v-311b06aa]{font-size:1em;font-weight:700}.email-list[data-v-311b06aa]{background:#f5f6fa;border-radius:6px;list-style-type:disc;margin:0;padding-left:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-311b06aa","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/_modules/I2P/ReviewEmailPage.vue
// module id = J4RV
// module chunks = 12